export enum Pages {
	About = 'over-ons',
	Footer = 'footer'
}
